import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apkInfo } from '@fleet/shared';
import { Button } from '../../design-system';
import { Eyebrow } from '../../components/ui/Eyebrow';
import { Modal } from '../../components/ui/Modal';
import { useSettings } from '../settings/settings.api';
import { AddCarForm } from './AddCarForm';
import { FleetFilters } from './FleetFilters';
import { FleetTable } from './FleetTable';
import { RdwCheckModal } from './RdwCheckModal';
import { useActiveCars } from './fleet.api';
import { useRdwCheck } from './rdw.api';

export function FleetPage() {
  const navigate = useNavigate();
  const cars = useActiveCars();
  const settings = useSettings();
  const apkDagen = settings.data?.apkReminderDays ?? 50;

  const [showAdd, setShowAdd] = useState(false);
  const [showRdw, setShowRdw] = useState(false);
  const rdwCheck = useRdwCheck();
  const [q, setQ] = useState('');
  const [brandstof, setBrandstof] = useState('');
  const [apk, setApk] = useState('');

  const all = cars.data ?? [];
  const filtered = all.filter((c) => {
    if (q) {
      const hay = `${c.kenteken} ${c.bestuurderNaam ?? ''} ${c.merk} ${c.model}`.toLowerCase();
      if (!hay.includes(q.toLowerCase())) return false;
    }
    if (brandstof && c.brandstof !== brandstof) return false;
    if (apk) {
      const urgent = apkInfo(c.apkVervaldatum, apkDagen).urgent;
      if (apk === 'actie' && !urgent) return false;
      if (apk === 'ok' && urgent) return false;
    }
    return true;
  });

  const count =
    filtered.length === all.length
      ? `${all.length} auto's`
      : `${filtered.length} van ${all.length} auto's`;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: 16,
          flexWrap: 'wrap',
        }}
      >
        <div>
          <Eyebrow>Wagenpark</Eyebrow>
          <h2 style={{ margin: '4px 0 0', fontSize: 22, fontWeight: 900, color: '#111111' }}>
            Alle actieve auto&apos;s.
          </h2>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button variant="primary" onClick={() => setShowAdd(true)}>
            + Auto toevoegen
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setShowRdw(true);
              rdwCheck.reset();
              rdwCheck.mutate();
            }}
            disabled={rdwCheck.isPending}
          >
            {rdwCheck.isPending ? 'RDW checken…' : 'RDW-check'}
          </Button>
          <Button variant="secondary" onClick={() => navigate('/archief')}>
            Archief
          </Button>
        </div>
      </div>

      <FleetFilters
        q={q}
        onQ={setQ}
        brandstof={brandstof}
        onBrandstof={setBrandstof}
        apk={apk}
        onApk={setApk}
        count={count}
      />
      {cars.isLoading ? (
        <div style={{ color: '#888888' }}>Wagenpark laden…</div>
      ) : (
        <FleetTable
          cars={filtered}
          apkReminderDays={apkDagen}
          onSelect={(k) => navigate(`/auto/${encodeURIComponent(k)}`)}
        />
      )}

      <Modal open={showAdd} onClose={() => setShowAdd(false)} title="Auto toevoegen">
        {/* Na het toevoegen meteen naar de auto zelf: daar staat de checklist van wat
            er nog moet gebeuren, en dat is precies waar je aan begint. */}
        <AddCarForm
          onAdded={(car) => {
            setShowAdd(false);
            navigate(`/auto/${encodeURIComponent(car.kenteken)}`);
          }}
          onCancel={() => setShowAdd(false)}
        />
      </Modal>

      <RdwCheckModal
        open={showRdw}
        onClose={() => setShowRdw(false)}
        result={rdwCheck.data ?? null}
        loading={rdwCheck.isPending}
        checkError={
          rdwCheck.isError ? 'RDW is momenteel niet bereikbaar. Probeer het later opnieuw.' : ''
        }
      />
    </div>
  );
}
